<template>
  <carousel-3d
    class="carousel-3d"
    :height="500"
    :controls-visible="true"
    :controlsWidth="35"
  >
    <slide :index="0">
      <div
        class="banner__image_exp"
        :style="'background-image: url(' + banner6 + ')'"
      ></div>
    </slide>
    <slide :index="1">
      <div
        class="banner__image_exp"
        :style="'background-image: url(' + banner7 + ')'"
      ></div>
    </slide>
    <slide :index="2">
      <div
        class="banner__image_exp"
        :style="'background-image: url(' + banner1 + ')'"
      ></div>
    </slide>
    <slide :index="3">
      <div
        class="banner__image_exp"
        :style="'background-image: url(' + banner9 + ')'"
      ></div>
    </slide>
    <slide :index="4">
      <div
        class="banner__image_exp"
        :style="'background-image: url(' + banner4 + ')'"
      ></div>
    </slide>
    <slide :index="5">
      <div
        class="banner__image_exp"
        :style="'background-image: url(' + banner3 + ')'"
      ></div>
    </slide>
    <slide :index="6">
      <div
        class="banner__image_exp"
        :style="'background-image: url(' + banner2 + ')'"
      ></div>
    </slide>
    <slide :index="7">
      <div
        class="banner__image_exp"
        :style="'background-image: url(' + banner5 + ')'"
      ></div>
    </slide>
    <slide :index="8">
      <div
        class="banner__image_exp"
        :style="'background-image: url(' + banner8 + ')'"
      ></div>
    </slide>
  </carousel-3d>
</template>

<script>
import { Carousel3d, Slide } from "vue-carousel-3d";

export default {
  props: ["banners"],
  data() {
    return {
      width: screen.width,
      banner1: "/img/carousel/um.png",
      banner2: "/img/carousel/dois.png",
      banner3: "/img/carousel/tres.png",
      banner4: "/img/carousel/quatro.png",
      banner5: "/img/carousel/cinco.png",
      banner6: "/img/carousel/seis.png",
      banner7: "/img/carousel/sete.png",
      banner8: "/img/carousel/oito.png",
      banner9: "/img/carousel/nove.png",
    };
  },
  components: {
    Carousel3d,
    Slide,
  },
  methods: {
    navigateTo(index) {
      this.slider = index;
      this.$refs.carouselSelector.goToPage(index);
    },
  },
  mounted() {
    // setTimeout(() => {
    //   this.$refs["carouselSelector"].onResize();
    //   this.$refs["carouselSelector"].goToPage(0);
    // }, 200);
  },
};
</script>
<style lang="scss" scoped>
.carousel-3d-slide {
  background-color: transparent !important;
  border: none !important;
  margin-bottom: 50px;
  .next[data-v-05517ad0],
  .prev[data-v-05517ad0] {
    color: white !important;
  }
  .next {
    color: white !important;
  }
  a {
    color: white !important;
  }
}
.banner__image_exp {
  background-position: top;
  background-size: contain;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
  @media (max-width: 1500px) {
    height: 500px;
    width: 350px;
  }
  @media (max-width: 996px) {
  }
}
.carousel-3d-controls[data-v-05517ad0] {
  width: 101% !important;
}
.next {
  color: white !important;
}
.next[data-v-05517ad0],
.prev[data-v-05517ad0] {
  color: white !important;
}
a {
  color: white !important;
}
</style>
